import React from "react";

/**
 * Floating WhatsApp chat button. Clicking it opens WhatsApp web/app with
 * a pre-filled message to the restaurant's number.
 */
export const WhatsAppFab = ({
  phone = "37126111722",
  message = "Sveiki! Vēlos rezervēt galdiņu Roze restorānā.",
}) => {
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-20 right-5 md:bottom-24 md:right-7 z-40 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white shadow-lg shadow-[#25D366]/30 hover:shadow-xl hover:shadow-[#25D366]/40 transition-all duration-300 hover:scale-105 active:scale-95"
    >
      {/* WhatsApp logo (inline SVG to avoid extra deps) */}
      <svg
        viewBox="0 0 32 32"
        fill="currentColor"
        aria-hidden="true"
        className="w-7 h-7 md:w-8 md:h-8"
      >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.014.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.945 2.722.945.187 0 .344-.014.518-.043 1.06-.171 1.96-.673 2.18-1.778.014-.043.014-.086.014-.143 0-.288 0-.575-.087-.846-.114-.314-.6-.5-.946-.572-.66-.157-.978-.388-1.6-.673-.286-.143-.572-.273-.858-.273z" />
        <path d="M16.05 0C7.41 0 .38 7.03.38 15.67c0 2.736.72 5.412 2.094 7.768L.144 31.36a.45.45 0 0 0 .55.553l8.117-2.34a15.66 15.66 0 0 0 7.24 1.766C24.69 31.34 31.72 24.31 31.72 15.67S24.69 0 16.05 0zm0 28.616a12.92 12.92 0 0 1-6.582-1.799l-.473-.28-4.846 1.396 1.402-4.717-.31-.49a12.94 12.94 0 0 1-1.974-6.88c0-7.144 5.81-12.953 12.95-12.953 7.145 0 12.954 5.81 12.954 12.953-.002 7.144-5.81 12.954-12.952 12.954z" />
      </svg>
    </a>
  );
};

export default WhatsAppFab;
